
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 17","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.783 8.084V.632m1.963 6.65a1.24 1.24 0 00-1.368.174c-2.303 1.997-2.16 6.12-.595 7.702 1.417 1.431 5.417.784 7.073-1.238.296-.361.37-.86.191-1.294a10.566 10.566 0 00-5.301-5.344zm14.287.802V.632m-1.958 6.65a1.24 1.24 0 011.368.174c2.303 1.997 2.159 6.12.594 7.702-1.417 1.431-5.417.784-7.073-1.238a1.274 1.274 0 01-.19-1.294 10.566 10.566 0 015.301-5.344z","stroke":"currentColor","stroke-width":"1.25","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    